import React, { FC } from 'react';
import MembershipMode from 'Jsx/CourseDetail/components/MembershipMode';
import CourseMode from './FloatingCard/CourseMode';
import Loader from 'crehana-ui/Loader';

import { usePricesContext } from 'Jsx/CourseDetail/Context/Prices';
import useCanEnrollWithFirstEnroll from 'Jsx/CourseDetail/hooks/useCanEnrollWithFirstEnroll';
import CustomSignupForm from 'Shared/CustomSignupForm';
import { useTranslation } from 'Jsx/Shared/Hooks/useTranslation';

interface TransactionInfoProps {
  isBuyable: boolean;
  course: any;
  CartButton: React.ReactElement;
  GiftButton: React.ReactElement;
  ShareButton: React.ReactElement;
  WishlistButton: React.ReactElement;
  isAppLoading: boolean;
  canShowMembershipFeature: boolean;
  canRenderCountdown: boolean;
  renderTransactionButtons(): React.ReactElement;
  userHasOrganization: boolean;
  showPaymentDialog(): void;
  canShowPaymentDialog: boolean;
  canEnroll: boolean;
  enrollmentUrl?: string;
}

const TransactionInfo: FC<TransactionInfoProps> = ({
  isBuyable,
  course,
  CartButton,
  GiftButton,
  ShareButton,
  WishlistButton,
  canShowMembershipFeature,
  renderTransactionButtons,
  isAppLoading,
  canRenderCountdown,
  userHasOrganization,
  showPaymentDialog,
  canShowPaymentDialog,
  canEnroll,
  enrollmentUrl,
}) => {
  const { loading: loadingPricesQuery, prices } = usePricesContext();
  const { canEnrollToCourseFreemium } = useCanEnrollWithFirstEnroll();
  const { t } = useTranslation();

  if (isAppLoading || loadingPricesQuery || !prices) {
    return (
      <div className="flex justify-center py-96">
        <Loader size={48} />
      </div>
    );
  }

  let SecondaryButtons: JSX.Element | null = (
    <div className="flex sm:justify-center mt-32 md:hidden">
      {isBuyable && !userHasOrganization && WishlistButton}
      {ShareButton}
      {isBuyable && !userHasOrganization && GiftButton}
    </div>
  );

  if (userHasOrganization && !canEnroll) {
    SecondaryButtons = null;
  }

  if (canEnrollToCourseFreemium) {
    return (
      <div className="p-24">
        <CustomSignupForm
          isCourseDetail
          registerButtonLabel={`${t('FREE_TRIAL')}*`}
          isRenderedIn="Course Detail"
          legalsCourse={t('VALID_ONLY')}
          courseEnrollmentUrl={enrollmentUrl}
        />
      </div>
    );
  }

  return (
    <div>
      {canShowMembershipFeature ? (
        <div>
          <MembershipMode
            course={course}
            GiftButton={GiftButton}
            CartButton={CartButton}
            WishlistButton={WishlistButton}
            showPaymentDialog={showPaymentDialog}
            canShowPaymentDialog={canShowPaymentDialog}
            mixpanelPage="Course detail v2"
            prices={prices}
          />
        </div>
      ) : (
        <CourseMode
          isBuyable={isBuyable}
          renderTransactionButtons={renderTransactionButtons}
          canRenderCountdown={canRenderCountdown}
          SecondaryButtons={SecondaryButtons}
          course={course}
        />
      )}
    </div>
  );
};

export default TransactionInfo;
